import AppLayout from './AppLayout';
import ErrorPage from '@components/common/ErrorPage';
import PropTypes from 'prop-types';
import React from 'react';
import {ErrorBoundary} from '@sentry/react';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {MAPBOX_ACCESS_TOKEN} from '@account/config';
import {MapAuthProvider} from '@apps-common/ui-maps/context';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const TITLE = 'Planet Account';

const HelmetStuff = ({children}) => (
  <HelmetProvider>
    <Helmet defaultTitle={TITLE} titleTemplate={`%s - ${TITLE}`} />
    {children}
  </HelmetProvider>
);

HelmetStuff.propTypes = {
  children: PropTypes.node,
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetStuff>
        <ErrorBoundary fallback={<ErrorPage />}>
          <MapAuthProvider mapboxAccessToken={MAPBOX_ACCESS_TOKEN}>
            <AppLayout />
          </MapAuthProvider>
        </ErrorBoundary>
      </HelmetStuff>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
